import React from 'react';
import { UtilityBar } from './components/UtilityBar';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { IntroSection } from './components/IntroSection';
import { ServicesSection } from './components/ServicesSection';
import { MarketStatsSection } from './components/MarketStatsSection';
import { AreasSection } from './components/AreasSection';
import { WhyChooseSection } from './components/WhyChooseSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { ToolsSection } from './components/ToolsSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal-text selection:bg-terracotta/20 selection:text-charcoal" data-id="element-0">
      <UtilityBar data-id="element-1" />
      <Navigation data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <IntroSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <MarketStatsSection data-id="element-7" />
        <AreasSection data-id="element-8" />
        <WhyChooseSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <AboutSection data-id="element-11" />
        <ToolsSection data-id="element-12" />
        <FinalCTASection data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}